import { StaticLayout } from './static-layout'

export function ContactPage() {
  return (
    <StaticLayout title="Contact us" description="Get in touch — feedback, bugs, anything.">
      <h2>Email</h2>
      <p>
        Reach us at <a href="mailto:hello@mkdn.app">hello@mkdn.app</a>. We read every message.
      </p>
      <h2>Bug reports</h2>
      <p>
        When reporting a bug, please include:
      </p>
      <ul>
        <li>What you were trying to do</li>
        <li>What happened (and what you expected to happen)</li>
        <li>Your browser and OS</li>
        <li>The document URL (if relevant)</li>
      </ul>
      <h2>Feature requests</h2>
      <p>
        We keep an eye on the <a href="/roadmap">roadmap</a>. Feel free to suggest additions — we
        prioritise based on what actually helps people write together.
      </p>
    </StaticLayout>
  )
}
